export default [
    {
        path: '/',
        redirect: '/c'
    },
    {
        path: '/f',
        name: '商品详情',
        component: () => import('@/views/store/storeInfo.vue')
    },
    {
        path: '/c',
        name: '门店主页面',
        component: () => import('@/views/store/shopDetail.vue')
    },
]



// WEBPACK FOOTER //
// ./src/router/routers.js